import { Image, type ImageProps } from "@/components/resources/components/ui/Image"

interface Props extends Partial<ImageProps> {
  name: string
  logo: string
  size?: number | `${number}`
}

export const ProjectLogo = ({ name, logo, size = "40", ...rest }: Props) => {
  return (
    <Image
      className="flex-shrink-0 rounded-full transform-gpu aspect-square"
      src={`https://static1.tokenterminal.com/${logo}`}
      width={size}
      height={size}
      alt={`${name} - Logo`}
      {...rest}
    />
  )
}
